module.exports = __webpack_public_path__ + "static/img/1.c5568a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1.png
// module id = W23E
// module chunks = 1